import React, { FC } from 'react';

import { useIntl } from 'react-intl';

import { theme } from 'styles/configure-theme';

import { MethodType } from './styled';

interface ICashAppMethod {
  isDisabled?: boolean;
  isRedesign?: boolean;
}

const CashAppMethod: FC<ICashAppMethod> = ({ isDisabled, isRedesign }) => {
  const { formatMessage } = useIntl();
  const textProps = isRedesign
    ? { variant: 'headerTwo', fontSize: 'lg', marginTop: '$2' }
    : { marginTop: { base: '$1' } };

  return (
    <MethodType
      color={isDisabled ? theme.token('text-disabled') : theme.token('text-default')}
      {...textProps}
    >
      {formatMessage({ id: 'cashAppPay' })}
    </MethodType>
  );
};

export default CashAppMethod;
